export default __webpack_public_path__ + "static/media/recorte_14.e79bc432.JPG";